module.exports = __webpack_public_path__ + "static/42-future-of-work-why-companies-should-focus-on-employee-engagement-ae1c41dca6dd98ada10d72d4cc78dae2.jpg";